export interface Criterion {
  name: string;
  weight: number;
  requirement: string;
}

export const SENIORITY_OPTIONS = [
  "Junior",
  "Mid-level",
  "Senior",
  "Lead",
  "Principal",
  "Executive",
] as const;
export type Seniority = (typeof SENIORITY_OPTIONS)[number];

export const INDUSTRY_OPTIONS = [
  "IT & Software",
  "Finance",
  "Healthcare",
  "Education",
  "Marketing",
  "Engineering",
  "Design",
  "Operations",
  "Sales",
  "Legal",
  "Human Resources",
  "Other",
] as const;
export type Industry = (typeof INDUSTRY_OPTIONS)[number];

export const EMPLOYMENT_TYPE_OPTIONS = [
  "Full-time",
  "Part-time",
  "Contract",
  "Internship",
] as const;
export type EmploymentType = (typeof EMPLOYMENT_TYPE_OPTIONS)[number];

export const LOCATION_OPTIONS = [
  "Remote",
  "On-site",
  "Hybrid",
] as const;
export type LocationType = (typeof LOCATION_OPTIONS)[number];

export interface Position {
  id: number;
  title: string;
  description: string | null;
  seniority: Seniority | null;
  industry: Industry | null;
  employment_type: EmploymentType | null;
  location: LocationType | null;
  created_at: string;
}

export interface HiringMatrix {
  id: number;
  position_id: number;
  position_title?: string;
  name: string;
  criteria: Criterion[];
  created_at: string;
}

export interface MatrixBreakdown {
  criterion: string;
  weight: number;
  score: number;
  notes: string;
}

export interface Candidate {
  id: number;
  position_id: number;
  matrix_id: number;
  filename: string | null;
  name: string | null;
  email: string | null;
  phone: string | null;
  years_experience: number | null;
  education: string | null;
  skills: string[];
  match_score: number;
  matrix_breakdown: MatrixBreakdown[] | null;
  recommendation: "strong_hire" | "consider" | "reject";
  summary: string | null;
  photo: string | null;
  archived: boolean;
  created_at: string;
}
